import alt from "../alt";
import indexBy from "lodash/keyBy";
import pickBy from "lodash/pickBy";
import PassFetcher from "../utils/PassFetcher";
import PassUtil from "../utils/PassUtil";
import PassActions from "../actions/PassActions";
import PersonStore from "./PersonStore";
import PersonActions from "../actions/PersonActions";
import config from "../config";

import GlobalNotificationActions from "../actions/GlobalNotificationActions";

class PassStore {
  constructor() {
    this.bindActions(PassActions);

    this.state = {
      hasUpdatedAll: false,
      hasUpdatedAllTypes: false,
      isFetchingAll: false,
      passes: {},
      passTypes: {}
    };

    this.exportPublicMethods({
      isFetchingFirstTime: this.isFetchingFirstTime.bind(this),
      hasPassesOfBucket: this.hasPassesOfBucket.bind(this),
      hasPasses: this.hasPasses.bind(this),
      getPassById: this.getPassById.bind(this),
      getPassTypeByCode: this.getPassTypeByCode.bind(this),
      getPassTypeById: this.getPassTypeById.bind(this),
      getPassesForCurrentEventBucket:
        this.getPassesForCurrentEventBucket.bind(this),
      getMembershipsForCurrentEventBucket: this.getMembershipsForCurrentEventBucket.bind(this),
    });
  }

  isFetchingFirstTime() {
    return this.state.isFetchingAll && !this.state.hasUpdatedAll;
  }

  hasPassesOfBucket(bucket) {
    return Object.values(this.state.passes).some(
      p => p.pass_bucket.id === bucket
    );
  }

  getPassesForCurrentEventBucket() {
    return pickBy(
      this.state.passes,
      p => p.event_bucket === config.event_bucket && !p.pass_bucket.is_membership
    );
  }

  getMembershipsForCurrentEventBucket() {
    return pickBy(
      this.state.passes,
      pass => pass.event_bucket === config.event_bucket && pass.pass_bucket.is_membership
    )
  }

  hasPasses() {
    return Object.keys(this.state.passes).length > 0;
  }

  getPassById(id) {
    return this.state.passes[id];
  }

  getPassTypeByCode(code) {
    return this.state.passTypes[code];
  }

  getPassTypeById(id) {
    return Object.values(this.state.passTypes).find(p => p.id === id);
  }

  onFetchPassTypes(opts) {
    PassFetcher.fetchTypes(PersonStore.getState().token, opts)
      .then(data => {
        PassActions.updatePassTypes(indexBy(data, "code"));
      })
      .catch(PassActions.fetchFailed);
  }

  onUpdatePassTypes(passTypes) {
    this.setState({ passTypes, hasUpdatedAllTypes: true });
  }

  onFetchAll(options) {
    // Don't fetch again if already fetching
    if (this.state.isFetchingAll) {
      return;
    }

    if (options) {
      if (options.firstTimeOnly && this.state.hasUpdatedAll) {
        // we've already fetched so no need to do it again
        return false;
      }

      if (options.reset) {
        this.setState({ hasUpdatedAll: false });
      }
    }

    this.setState({ isFetchingAll: true });
    PassFetcher.fetchAll(PersonStore.getState().token)
      .then(data => {
        PassActions.updatePasses(indexBy(data, "id"));
        this.setState({ isFetchingAll: false });
      })
      .catch(PassActions.fetchFailed);
  }

  onFetchOne(id) {
    PassFetcher.fetchOne(PersonStore.getState().token, id)
      .then(data => {
        PassActions.updatePass(id, data);
      })
      .catch(PassActions.fetchFailed);
  }

  onUpdatePasses(passes) {
    this.setState({ passes, hasUpdatedAll: true });
  }

  onUpdatePass(data) {
    this.state.passes[data.id] = data.pass;
    this.setState(this.state);
  }

  onEditPass(newData) {
    PassUtil.edit(newData.id, newData.values)
      .then(data => {
        PassActions.updatePass(newData.id, data);

        // Dispatch person update in case supplementary data images/etc. changed
        PersonActions.fetchSelf();
      })
      .catch(PassActions.editFailed);
  }

  onTransferPass({ id, destinationEmail }) {
    PassUtil.transfer(id, destinationEmail, PersonStore.getState().token)
      .then(data => {
        PassActions.updatePass(id, data);
      })
      .catch(PassActions.editFailed);
  }

  onResendPassTransfer(id) {
    PassUtil.resendTransfer(id, PersonStore.getState().token)
      .then(data => {
        GlobalNotificationActions.notify(
          `Pass transfer resent to ${data.pending_transfer_recipient}.`
        );
        PassActions.updatePass(id, data);
      })
      .catch(PassActions.editFailed);
  }

  onCancelPassTransfer(id) {
    PassUtil.cancelTransfer(id, PersonStore.getState().token)
      .then(data => {
        GlobalNotificationActions.notify(`Pass transfer canceled.`);
        PassActions.updatePass(id, data);
      })
      .catch(PassActions.editFailed);
  }

  onAcceptPassTransfer({ id, token }) {
    PassUtil.acceptTransfer(id, token, PersonStore.getState().token)
      .then(data => {
        PassActions.updatePass(id, data);

        // Sundance: Redirect back to Sundance account page
        if (TENANT.sundance_login) {
          window.location.href = `${
            TENANT.sundance_external_schedule_url ||
            "https://fixme-sundance-redirect"
          }`;
        }
      })
      .catch(PassActions.editFailed);
  }

  onSendGiftPass({ id, opts }) {
    PassUtil.sendGiftPass(id, opts, PersonStore.getState().token)
      .then(data => {
        PassActions.updatePass(id, data);
      })
      .catch(PassActions.editFailed);
  }

  onEditFailed(e) {
    window.alert(`Sorry, something went wrong editing your pass: ${e.message}`);
    throw e;
  }

  onFetchFailed(e) {
    this.setState({ isFetchingAll: false });
    throw e;
  }
}

export default alt.createStore(PassStore, "PassStore");



// WEBPACK FOOTER //
// ./src/app/stores/PassStore.js